import { useMutation, gql } from "@apollo/client";

export const UPDATE_VIEWER = gql`
  mutation updateViewer($input: UpdateViewerInput!) {
    updateViewer(input: $input) {
      viewer {
        id
      }
    }
  }
`;

export default (options) => {
  return useMutation(UPDATE_VIEWER, options);
};
